export const transformNumberToConcatString = (value: string) => {
  return value?.replace(/[_-]/g, "");
};
